import React from 'react';
import { RestaurantSection } from '../components';

const Restaurant = () => {
  return (
    <>
      <RestaurantSection />
    </>
  );
};

export default Restaurant;
